import { env } from "@/common/env/client.mjs";

export const getRevalidateTime = (revalidateTime = 86_400) => {
  const isProduction = env.NODE_ENV === "production";

  if (isProduction) return revalidateTime;

  return 1;
};
